// extracted by mini-css-extract-plugin
export default {"container":"---------packages-corgi-x-src-components-StyledSelect-components-MultiButtonList-module__container"};